import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CasoGeneralComponent } from 'defcol-caso-general'
import { obtenerDatosLlaves } from '../../store/actions/recepciona-caso-action'
import RecepcionaCasoAsignado from './formularios'
import { Auth } from 'recupero-comunes'
import { useLocation, useNavigate } from 'react-router-dom'
import { Card, Container } from 'react-bootstrap'

const RecepcionaCaso = () => {

  const {state}=useLocation()
  const idCasoLocation=state?.row?.IdCaso ? state.row.IdCaso :115
  const idImplicado=state?.row?.IdImplicado ? state.row.IdImplicado :1
  const idOrganizacionCaso =state?.row?.idOrganizacionCaso  ? state.row.idOrganizacionCaso:8600399880
  const { rutUsuario } = Auth.currentUser()

  const dispatch=useDispatch()

 
 useEffect(() => {     

   dispatch(obtenerDatosLlaves({"idCaso":idCasoLocation,"idImplicado":idImplicado,"idOrgCaso":idOrganizacionCaso, "idUsuario": rutUsuario}));    

}, [dispatch])

  return (
    <div>
      <Container>
        <Card className='mt-2'>
          <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >{`Antecedentes del Caso Asignado ${idCasoLocation}`}</Card.Header>
          <Card.Body> 
          <CasoGeneralComponent idCaso={idCasoLocation} idImplicado={idImplicado} idOrganizacionCaso={idOrganizacionCaso}/>
          </Card.Body>
        </Card>
      </Container>      
      <RecepcionaCasoAsignado/>
    </div>
  )
}

export default RecepcionaCaso